import React, { useCallback, useState, useEffect } from "react";
import MstService from "../../../services/mst.service";
import requestAndErrorHandler from "../../../services/responseAndErrorHandler";
import { Row, Col, Form, Button, Container } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";
import LayoutContainer from "../../../FUSComponents/LayoutContainer/LayoutContainer";
import { FUSButton } from "../../../FUSComponents/FUSElements/FUSButton/FUSButton";
import FUSModal from "../../../FUSComponents/FUSModal/FUSModal";
import { toast } from "react-toastify";
import FileSaver from "file-saver";
import { EXPENSE_CATEGORY_EXCEL_BASE64 } from "../../../services/sample_file";
import { useMediaQuery } from "react-responsive";
import TokenService from "../../../services/token.service";
import VARIABLES from "../../../services/variable.service";
import axios from "axios";

function ExpenseCategory() {
  const [expensedata, setExpenseData] = useState([]);
  const [showModal, setShowModal] = useState({
    state: false,
    type: null,
  });
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [formData, setFormData] = useState({
    category_name: "",
    is_active: "",
    type: "ALL",
  });
  const isMobile = useMediaQuery({ minWidth: 200, maxWidth: 576 });
  const getExpenseCategoryData = () => {
    MstService.crudExpenseCategory({
      type: "ALL",
    })
      .then((response) => {
        if (response?.data?.errorCode === 0) {
          setExpenseData(response?.data?.data);
        }
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  };
  useEffect(() => {
    getExpenseCategoryData();
  }, [isLoading]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const expenseModal = () => {
    setFormData((prevData) => ({
      ...prevData,
      type: "INSERT",
    }));
    //setShowModal((prev) => ({ ...prev, state: true }));
    setShowModal((prev) => ({
      ...prev,
      state: true,
      type: "INSERT",
    }));
  };
  const uploadData = (overrides) => {
    const token = TokenService.getLocalAccessToken();
    const strURL = `${VARIABLES.BASE_URL}uploadCrudAgencyExpenseCategory`;
    const formData = new FormData();
    formData.append("uploadfile", selectedFile);

    axios({
      method: "post",
      url: strURL,
      data: formData,
      headers: {
        "Content-Type": `multipart/form-data;`,
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        if (response?.data?.errorCode === -444) {
          setIsFilePicked(false);
          setSelectedFile();
        } else {
          let text = response?.data?.message;
          if (window.confirm(text) === true) {
            setSelectedFile();
            setIsFilePicked(false);
            setIsLoading(!isLoading);
          }
          setShowModal((prev) => ({ ...prev, state: false }));
        }
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  };

  const handleSubmission = () => {
    const fileExt = selectedFile?.name.substring(
      selectedFile?.name.lastIndexOf(".")
    );
    if (fileExt === ".xlsx" || fileExt === ".xls") {
      var confirm = window.confirm(
        "PLease ensure your file constains expense !"
      );
      if (!confirm) {
        setIsLoading((loadingValue) => !loadingValue);
      } else {
        uploadData(false);
      }
    } else {
      const successToast = toast.success("Please Upload a Excel file", {
        position: "bottom-left",
        autoClose: false,
      });
      setTimeout(() => {
        toast.dismiss(successToast);
      }, 2000);
    }
  };

  // for handling excel upload

  const changeHandler = (event) => {
    if (event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
      setIsFilePicked(true);
    } else {
      setIsFilePicked(false);
    }
  };

  const addNewExpenseCategory = () => {
    setIsEdit(false);
    MstService.crudExpenseCategory(formData)
      .then((res) => {
        if (res?.data?.errorCode === 0) {
          setShowModal((prev) => ({ ...prev, state: false }));
          setIsLoading((isLoading) => !isLoading);

          const successToast = toast.success(`${res?.data?.message}`, {
            position: "bottom-left",
            autoClose: false,
          });
          setTimeout(() => {
            toast.dismiss(successToast);
          }, 2000);
        }
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
    setFormData({
      type_name: "",
      type: "ALL",
      is_active: "",
    });
  };

  const handleEditClick = (row) => {
    setIsEdit(true);
    MstService.crudExpenseCategory({ type: "GET", id: row.id })
      .then((res) => {
        setFormData(res?.data?.data[0]);
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  };

  const handleEditExpense = () => {
    MstService.crudExpenseCategory({ ...formData, type: "UPDATE" })
      .then((res) => {
        if (res?.data?.errorCode === 0) {
          setIsEdit(false);
          setShowModal((prev) => ({ ...prev, state: false }));
          setFormData({
            category_name: "",
            type: "ALL",
            is_active: "",
          });
          setIsLoading((isLoading) => !isLoading);

          const successToast = toast.success(`${res?.data?.message}`, {
            position: "bottom-left",
            autoClose: false,
          });
          setTimeout(() => {
            toast.dismiss(successToast);
          }, 2000);
        }
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  };

  const handleDelete = useCallback((row) => {
    const isDelete = window.confirm(`Are you want to delete Expense Category`);
    if (isDelete) {
      MstService.crudExpenseCategory({ id: row.id, type: "DELETE" })
        .then((response) => {
          if (
            response?.data?.errorCode === 201 ||
            response?.data?.errorCode === 200 ||
            response?.data?.errorCode === 0
          ) {
            setExpenseData((oldValues) => {
              return oldValues.filter((item) => item.id !== row.id);
            });

            const successToast = toast.success(`${response?.data?.message}`, {
              position: "bottom-left",
              autoClose: false,
            });
            setTimeout(() => {
              toast.dismiss(successToast);
            }, 2000);
          }
          if (
            response?.data?.errorCode === -101 ||
            response?.data?.errorCode === -102 ||
            response?.data?.errorCode === -103 ||
            response?.data?.errorCode === -100
          ) {
            const successToast = toast.error(`${response?.data?.message}`, {
              position: "bottom-left",
              autoClose: false,
            });
            setTimeout(() => {
              toast.dismiss(successToast);
            }, 2000);
          }
        })
        .catch((error) => {
          requestAndErrorHandler.errorHandler(error);
        });
    }
  }, []);

  const columns = [
    {
      dataField: "category_name",
      text: "Expense Category",
    },
    {
      dataField: "remove",
      text: "Status",
      formatter: (cellContent, row) => {
        return (
          <>
            {row?.is_active ? (
              <sapn className="text-success">Active</sapn>
            ) : (
              <sapn className="text-danger">Inactive</sapn>
            )}
          </>
        );
      },
      editable: false,
    },
    {
      dataField: "remove",
      text: "Action",
      formatter: (cellContent, row) => {
        return (
          <>
            <div className="d-flex gap-3">
              <div>
                <FUSButton
                  className={"action_button_style"}
                  iconSrc="md"
                  iconName="MdOutlineModeEdit"
                  iconSize={15}
                  buttonType="lightgray"
                  onClick={() => {
                    setShowModal((prev) => ({
                      ...prev,
                      state: true,
                      type: "EDIT_EXPENSE",
                    }));
                    handleEditClick(row);
                  }}
                />
              </div>
              <div>
                <FUSButton
                  className={"action_button_style"}
                  iconSrc="md"
                  iconName="MdDeleteForever"
                  iconSize={15}
                  buttonType="lightdanger"
                  onClick={() => handleDelete(row)}
                />
              </div>
            </div>
          </>
        );
      },
      editable: false,
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );
  const options = {
    paginationSize: 4,
    pageStartIndex: 0,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "7",
        value: 7,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "All",
        value: expensedata.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };

  const handleDownload = () => {
    let sliceSize = 1024;
    let byteCharacters = atob(EXPENSE_CATEGORY_EXCEL_BASE64);
    let bytesLength = byteCharacters.length;
    let slicesCount = Math.ceil(bytesLength / sliceSize);
    let byteArrays = new Array(slicesCount);
    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      let begin = sliceIndex * sliceSize;
      let end = Math.min(begin + sliceSize, bytesLength);
      let bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    FileSaver.saveAs(
      new Blob(byteArrays, { type: "application/vnd.ms-excel" }),
      "sample_expense_category_file.xlsx"
    );
  };

  return (
    <>
      <LayoutContainer
        title1={"Settings"}
        title2={"Settings"}
        title3={"Expense Category"}
        right={
          <>
            <div className="d-flex text-center pt-1 align-items-center">
              <span className="beat_file_sample d-none d-sm-block">
                Upload excel file in
              </span>
              &nbsp;
              <a
                className="beat_file_sample themeColorBlue"
                style={{ cursor: "pointer" }}
                onClick={handleDownload}
              >
                Link sample expense category excel format file
              </a>
            </div>
          </>
        }
      >
        <div className="px-1 py-2">
          <div>
            <div className="border_bottom_color">
              <div className="row">
                <div className="col-12 d-flex justify-content-end gap-3">
                  <FUSButton
                    iconSrc={"fa6"}
                    iconName={"FaPlus"}
                    iconColor={"#ffffff"}
                    iconSize={14}
                    labelText={"Add Expense Category"}
                    buttonType="primary"
                    onClick={expenseModal}
                  />
                  <FUSButton
                    iconSrc={"md"}
                    iconName={"MdOutlineFileDownload"}
                    iconSize={19}
                    labelText={
                      isMobile ? "Expense List" : "Import Expense Category List"
                    }
                    buttonType="primary"
                    onClick={() =>
                      setShowModal((prev) => ({
                        ...prev,
                        state: true,
                        type: "IMPORT_EXEL",
                      }))
                    }
                  />
                </div>
              </div>
            </div>
            <div className="px-2 mt-3">
              <div className="col-lg-11 px-1 col-12">
                <BootstrapTable
                  classes="border border-1"
                  keyField="id"
                  data={expensedata}
                  columns={columns}
                  sizePerPage={5}
                  filter={filterFactory()}
                  pagination={paginationFactory(options)}
                />
              </div>
            </div>
            {showModal.state &&
            (showModal.type === "EDIT_EXPENSE" ||
              showModal.type === "INSERT") ? (
              <FUSModal
                title={
                  !isEdit ? "Add Expense Category" : "Edit Expense Category"
                }
                showModal={showModal.state}
                size={"md"}
                handleClose={() => {
                  setShowModal((prev) => ({ ...prev, state: false, type: "" }));
                  setIsEdit(false);
                }}
                centered
              >
                <Form>
                  <Row>
                    <Form.Group
                      as={Col}
                      md="12"
                      controlId="validationCustom03"
                      className="mx-0 px-0"
                    >
                      <div>
                        <span className="label_style">Expense Category</span>
                        <Form.Control
                          className="py-2 my-1 text_style"
                          onChange={handleChange}
                          type="text"
                          value={formData?.category_name}
                          name="category_name"
                          placeholder="Enter here"
                        />
                      </div>
                      {isEdit && (
                        <>
                          <div className="mt-2">
                            <span className="label_style">Status</span>
                            <Form.Select
                              className="py-2 my-1 text_style"
                              name="is_active"
                              value={formData.is_active}
                              onChange={handleChange}
                            >
                              <option value="true">Activate</option>
                              <option value="false">Deactivate </option>
                            </Form.Select>
                          </div>
                        </>
                      )}
                    </Form.Group>
                  </Row>

                  <div className="mt-3">
                    {formData.category_name &&
                    formData.category_name !== "" &&
                    formData.category_name !== null &&
                    formData.category_name !== undefined ? (
                      <FUSButton
                        className={"form-control"}
                        buttonType="primary"
                        onClick={
                          isEdit ? handleEditExpense : addNewExpenseCategory
                        }
                        labelText={"Save Changes"}
                      />
                    ) : null}
                  </div>
                </Form>
              </FUSModal>
            ) : null}

            {showModal.state && showModal.type === "IMPORT_EXEL" ? (
              <FUSModal
                title={"Import Exel Expense Category"}
                showModal={showModal.state}
                size={"md"}
                handleClose={() =>
                  setShowModal((prev) => ({ ...prev, state: false, type: "" }))
                }
                centered
              >
                {showModal.type === "IMPORT_EXEL" ? (
                  <Form>
                    <Row>
                      <Form.Group
                        as={Col}
                        md="12"
                        controlId="validationCustom03"
                      >
                        <div>
                          <div className="row d-flex justify-content-center mt25">
                            <div className="col-md-auto">
                              <Form.Group
                                controlId="formFileLg"
                                className="mb-3"
                              >
                                <Container>
                                  <Row className="row-bottom-margin">
                                    <Form.Group as={Col}>
                                      <Form.Label>
                                        Upload expense List
                                      </Form.Label>
                                      <Form.Control
                                        type="file"
                                        size="sm"
                                        onChange={changeHandler}
                                        accept=".xls,.xlsx"
                                      />
                                    </Form.Group>
                                  </Row>
                                  <Row className="row-bottom-margin mt25">
                                    {isFilePicked && (
                                      <Form.Group as={Col}>
                                        <Form.Label>
                                          {isFilePicked ? (
                                            <div>
                                              <p className="p0">
                                                {`Filename: ${selectedFile?.name} `}{" "}
                                              </p>
                                              <p className="p0">
                                                {`  Filetype: ${selectedFile?.type} `}{" "}
                                              </p>
                                              <p className="p0">
                                                {`  Size in bytes: ${selectedFile?.size}`}{" "}
                                              </p>
                                              <p className="p0">
                                                {`  lastModifiedDate: ${selectedFile?.lastModifiedDate.toLocaleDateString()} `}{" "}
                                              </p>
                                            </div>
                                          ) : (
                                            <span>
                                              Select a file to show details
                                            </span>
                                          )}
                                        </Form.Label>
                                        &nbsp; &nbsp; &nbsp; &nbsp;
                                        <Button
                                          variant="primary"
                                          className="btn btn-sm"
                                          onClick={handleSubmission}
                                        >
                                          Upload
                                        </Button>
                                      </Form.Group>
                                    )}
                                  </Row>
                                </Container>
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                      </Form.Group>
                    </Row>
                  </Form>
                ) : null}
              </FUSModal>
            ) : null}
          </div>
        </div>
      </LayoutContainer>
    </>
  );
}

export default ExpenseCategory;
